import React, {useEffect, useState} from 'react';
import useTitle from '@/hook/useTitle';
import {useNavigate} from 'react-router-dom';
import {Result, Button} from 'antd';

export default function AbbvErrorPage() {
    useTitle('ERROR');
    const navigate = useNavigate();

    const [errorMsg, setErrorMsg] = useState('');

    useEffect(() => {
        let errorMsg = window.location.href.split('?')[1].split('=')[1];
        setErrorMsg(decodeURI(errorMsg));
    }, []);

    return (
        <Result
            status="500"
            style={{marginTop: 200, backgroundColor: 'transparent'}}
            title="500"
            subTitle={errorMsg}
            extra={
                <Button type="primary" onClick={() => navigate('/', {replace: true})}>
                    返回首页
                </Button>
            }
        />
    );
}
